import { Subject } from "../../../util/Subject";
import { BulkAddDialogOpen } from "./BulkAddDialogTypes";

export const bulkAddDialogOpened = new Subject<BulkAddDialogOpen>();

export const bulkAddDialogClosed = new Subject();
